var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
var LegalEntitySelector = function (_a) {
    var entities = _a.entities, selectedId = _a.selectedId, onChange = _a.onChange;
    var items = useMemo(function () { return entities.map(function (e) { return ({ key: e.id, label: e.name }); }); }, [entities]);
    var selectedItem = useMemo(function () { return items.find(function (i) { return i.key === selectedId; }) || null; }, [
        items,
        selectedId,
    ]);
    if (entities.length > 5) {
        return (_jsx("div", __assign({ className: "margin10B" }, { children: _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-md-3" }, { children: _jsx(AutoComplete, { id: "legalEntitySelector", items: items, value: selectedItem, onChange: function (item) {
                            if (!item)
                                return;
                            var entity = entities.find(function (e) { return e.id === item.key; });
                            if (entity)
                                onChange(entity);
                        }, mode: "edit", canClear: false }) })) })) })));
    }
    return (_jsx("ul", __assign({ className: "nav nav-tabs nav-tabs-heading", role: "tablist" }, { children: entities.map(function (entity) { return (_jsx("li", __assign({ role: "presentation", className: "tab".concat(selectedId === entity.id ? ' active' : ''), onClick: function () { return onChange(entity); } }, { children: _jsx("span", { children: entity.name }) }), entity.id)); }) })));
};
export default LegalEntitySelector;
